"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _axios = _interopRequireDefault(require("axios"));

var _Message = require("../../../ui-components/Message");

var _ErrorMessages = _interopRequireDefault(require("../../ErrorMessages"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _constants = require("@insided/shared/constants");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var FederatedSearchSyncStatus = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(FederatedSearchSyncStatus, _Component);

  var _super = _createSuper(FederatedSearchSyncStatus);

  function FederatedSearchSyncStatus(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FederatedSearchSyncStatus);
    _this = _super.call(this, props);

    _this.setState({
      isFederatedSearchActive: props.isFederatedSearchActive
    });

    _this.onSync = _this.onSync.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(FederatedSearchSyncStatus, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.federatedSearchSyncInProgress !== prevProps.federatedSearchSyncInProgress) {
        this.setState({
          syncInProgress: this.props.federatedSearchSyncInProgress
        });
      }

      if (this.props.isFederatedSearchActive !== prevProps.isFederatedSearchActive) {
        this.setState({
          isFederatedSearchActive: this.props.isFederatedSearchActive
        });
      }
    }
  }, {
    key: "onSync",
    value: function onSync() {
      var _this2 = this;

      this.setState({
        syncInProgress: true,
        messageType: null
      });

      _axios.default.post('/integration/zendesk/sync', []).then(function (res) {
        var successMessage = "".concat(res.data.message, "!");

        _this2.setState({
          syncInProgress: false,
          messageType: 'success',
          message: successMessage
        });
      }).catch(function (error) {
        _this2.setState({
          syncInProgress: false
        });

        if (error.response === undefined) {
          _this2.setState({
            messageType: 'error',
            message: _ErrorMessages.default.internetConnection
          });

          return;
        }

        if (error.response.status === 409) {
          _this2.setState({
            messageType: 'error',
            message: _ErrorMessages.default.configurationExists
          });

          return;
        }

        _this2.setState({
          messageType: 'error',
          message: 'Sorry, synchronisation failed, please try again.'
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state = this.state,
          syncInProgress = _this$state.syncInProgress,
          message = _this$state.message,
          messageType = _this$state.messageType,
          isFederatedSearchActive = _this$state.isFederatedSearchActive;

      if (!isFederatedSearchActive) {
        return null;
      }

      return (0, _preact.h)("div", {
        className: "integrations-zendesk__federated-search-sync-status integration-zendesk-sync-status"
      }, syncInProgress && (0, _preact.h)(_Message.Message, {
        fullWidth: true,
        text: "Content synchronization is in progress. Please refresh the page later to check the status."
      }), !syncInProgress && messageType === 'error' && (0, _preact.h)(_Message.Message, {
        fullWidth: true,
        variant: "warning"
      }, (0, _preact.h)("div", null, (0, _preact.h)("p", null, message), (0, _preact.h)(_Button.default, {
        className: "button-sync-now",
        title: "Sync now",
        startIcon: "sync",
        onClick: function onClick() {
          return _this3.onSync();
        }
      }))), !syncInProgress && (messageType === 'success' || messageType === undefined) && (0, _preact.h)(_Message.Message, {
        fullWidth: true
      }, (0, _preact.h)("div", null, (0, _preact.h)("p", null, "The search index is updated automatically every day. Run a synchronization if you\u2019d like to apply content updates to $", _constants.PLATFORM_BRAND_NAME, " immediately."), (0, _preact.h)(_Button.default, {
        className: "button-sync-now",
        title: "Sync now",
        startIcon: "sync",
        onClick: function onClick() {
          return _this3.onSync();
        }
      }))));
    }
  }]);
  return FederatedSearchSyncStatus;
}(_preact.Component);

var _default = FederatedSearchSyncStatus;
exports.default = _default;